import { ActionReducerMap, MetaReducer } from '@ngrx/store'
import { AccountEffects } from 'libs/gb-dashboard/account/data-access/src/lib/+state/account.effects'
import { accountReducer } from 'libs/gb-dashboard/account/data-access/src/lib/+state/account.reducer'
import { DashboardState } from 'libs/gb-dashboard/core/data-access/src/lib/+state/dashboard-state.models'
import { DashboardHydrationEffects } from 'libs/gb-dashboard/shared/dashboard-hydration/src/lib/+state/dashboard-hydration.effects'
import { baseHydrationMetaReducer } from 'libs/shared/hydration/src/lib/+state/base-hydration.reducer'
import { flushDashboardMetaReducer } from './dashboard-flush-state.reducer'

export const appReducers: ActionReducerMap<DashboardState> = {
  account: accountReducer,
}

export const appMetaReducers: MetaReducer[] = [baseHydrationMetaReducer, flushDashboardMetaReducer]

export const appEffects = [AccountEffects, DashboardHydrationEffects]
